import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {Constants} from "../../constants";

@Component({
  selector: 'app-services-section',
  templateUrl: './services-section.component.html',
  styleUrls: ['./services-section.component.scss'],
  imports: [NgOptimizedImage]
})
export class ServicesSectionComponent {

  protected readonly company = Constants.Company;

}
